import angular from 'angular';
import uiRouter from 'angular-ui-router';
import differentialComponent from './differential.component';
import differentialListComponent from './differential-list.component';
import differentialDetailComponent from './differential-detail.component';
import differentialService from './differential.service';

let differentialModule = angular.module('differential', [
  uiRouter
])

.service('Differential', differentialService)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/differential');

  $stateProvider
    .state('differential', {
      component: 'differential'
    })
    .state('differential.list', {
      url: '/differential',
      component: 'differentialList'
    })
    .state('differential.create', {
      url: '/differential/new',
      component: 'differentialDetail',
      params: {
      	id: ""
      }
    })
    .state('differential.edit', {
      url: '/differential/:id/edit',
      component: 'differentialDetail',
      params: {
        id: ""
      }
    });
})

.component('differential', differentialComponent)
.component('differentialList', differentialListComponent)
.component('differentialDetail', differentialDetailComponent)

.name;

export default differentialModule;



// WEBPACK FOOTER //
// ./client/app/components/differential/differential.js